module.exports = __webpack_public_path__ + "static/media/icono_mas.c4a66e1b.svg";